import { waitForServicesLibrary } from '@boschrexroth/dc.ncj.frontend-services-npm/dist/static-lib';
import { defineCustomElements } from '@boschrexroth/dc-ui-library-website/loader';
import applyNewsletterEmail from '@/components/footer-navigation/services/applyNewsletterEmail/applyNewsletterEmail';

export default async function () {
    defineCustomElements();
    await waitForServicesLibrary();
    setTimeout(() => applyNewsletterEmail(), 1000);
}
